import React from "react";
import { Table } from "react-bootstrap";
import "../../../assets/styles/customTable.scss";

const RoutesListTable = ({ data, selectedOption, filters }) => {
  const items = Array.isArray(data.items) ? data.items : [];

  const filteredData = items.filter((row) => {
    if (selectedOption === "terminal") {
      return (
        (row.terminalEx || "").includes(filters.terminalEx || "") &&
        (row.terminalDr || "").includes(filters.terminalDr || "")
      );
    }
    if (selectedOption === "postcode") {
      return (row.postcode || "").includes(filters.postcode || "");
    }
    if (selectedOption === "cityAndPostcode") {
      return (
        (row.cityName || "").includes(filters.city || "") &&
        (row.postcode || "").includes(filters.postcode || "")
      );
    }

    if (selectedOption === "cityAndStreet") {
      return (
        (row.cityName || "").includes(filters.city || "") &&
        (row.streetName || "").includes(filters.street || "")
      );
    }
    return true; 
  });

  return (
    <Table responsive striped bordered hover size="sm" className="custom-table">
      <thead>
        <tr>
          <th>EX</th>
          <th>DR</th>
          {selectedOption === "postcode" ? (
            <>
              <th>Kod pocztowy</th>
            </>
          ) : null}
          {selectedOption === "cityAndPostcode" ||
          selectedOption === "cityAndStreet" ? (
            <>
              <th>Miejscowość</th>
              <th>
                {selectedOption === "cityAndStreet" ? "Ulica" : "Kod pocztowy"}
              </th>
            </>
          ) : null}
          <th>EX_PN</th>
          <th>EX_WT</th>
          <th>EX_SR</th>
          <th>EX_CZ</th>
          <th>EX_PT</th>
          <th>EX_SO</th>
          <th>DR_PN</th>
          <th>DR_WT</th>
          <th>DR_SR</th>
          <th>DR_CZ</th>
          <th>DR_PT</th>
          <th>DR_SO</th>
        </tr>
      </thead>
      <tbody>
        {filteredData.length > 0 ? (
          filteredData.map((row, index) => (
            <tr key={index}>
              <td>{row.terminalEx}</td>
              <td>{row.terminalDr}</td>
              {selectedOption === "postcode" && <td>{row.postcode}</td>}
              {selectedOption === "cityAndPostcode" && (
                <>
                  <td>{row.cityName}</td>
                  <td>{row.postcode}</td>
                </>
              )}
              {selectedOption === "cityAndStreet" && (
                <>
                  <td>{row.cityName}</td>
                  <td>{row.streetName || "N/A"}</td>
                </>
              )}
              <td>{row.exPn}</td>
              <td>{row.exWt}</td>
              <td>{row.exSr}</td>
              <td>{row.exCz}</td>
              <td>{row.exPt}</td>
              <td>{row.exSo}</td>
              <td>{row.drPn}</td>
              <td>{row.drWt}</td>
              <td>{row.drSr}</td>
              <td>{row.drCz}</td>
              <td>{row.drPt}</td>
              <td>{row.drSo}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="16" className="text-center">
              Brak danych
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default RoutesListTable;
